export default "__VITE_ASSET__CQd59XXm__"